import React from 'react';
import PropTypes from 'prop-types';
import './LoaderSpinner.scss';

const LoaderSpinner = ({ children }) => (
  <div className="LoaderSpinner">
    <div className="LoaderSpinner__SpinnerWrap">
      <div className="LoaderSpinner__SpinnerWrap__Spinner" />
    </div>
    {children}
  </div>
);
export default LoaderSpinner;

LoaderSpinner.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
};




// WEBPACK FOOTER //
// ./src/components/LoaderSpinner/LoaderSpinner.jsx